module.exports = __webpack_public_path__ + "img/review.5f1cc98b.png";